module.exports = __webpack_public_path__ + "static/media/batt-conn.ac31c759.gif";